<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-03 11:40:22
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-08-05 15:12:36
 * @Description: 主页底部
 -->
<template>
  <div class="footer-wrapper">
    <p class="tips">市场有风险，出借需谨慎</p>
    <div class="footer-box">
      <div class="footer-content">
        <div class="left">
          <ul class="link-wrapper">
            <router-link class="link-item" to="/about-us">关于我们</router-link>
            <router-link class="link-item" to="/about-us">公司介绍</router-link>
            <router-link class="link-item" to="/about-us/join-us">加入我们</router-link>
          </ul>
          <div class="attention">
            <!-- <span class="item">关注我们</span>
            <div class="wechat item">
              <img src="https://files.jinr.com/jinr-index/img/wechat@2x.png" alt="" srcset="" />
              <img
                class="wechat-code qr-code"
                src="https://files.jinr.com/jinr-index/img/wechat-code@2x.png"
                alt=""
              />
            </div> -->
            <!-- <div class="app-download item">
              <div class="btn btn-ios"></div>
              <img
                class="app-code qr-code"
                src="../assets/images/qr-ios.png"
                alt=""
              />
            </div>
            <div class="app-download item">
              <div class="btn btn-android"></div>
              <img
                class="app-code qr-code"
                src="../assets/images/qr-android.png"
                alt=""
              />
            </div> -->
          </div>
          <div class="icon-wrapper">
            <img src="https://files.jinr.com/jinr-index/img/footer-icon-01.png" alt="" srcset="" />
            <img src="https://files.jinr.com/jinr-index/img/footer-icon-02.png" alt="" srcset="" />
            <img src="https://files.jinr.com/jinr-index/img/footer-icon-03.png" alt="" srcset="" />
            <img src="https://files.jinr.com/jinr-index/img/footer-icon-04.png" alt="" srcset="" />
          </div>
        </div>
        <div class="right">
          <p class="contract-us">联系我们</p>
          <p class="contract-way">
            <span>咨询电话：10102015</span><span>商务合作：BD@jinr.com</span>
          </p>
          <p class="postcode">邮编：361000</p>
          <!-- <p class="phone">举报电话：0592-5333029</p> -->
        </div>
      </div>
    </div>
    <p class="copyright">
      <span>
        厦门吉才神网络借贷信息中介服务有限公司&nbsp;&nbsp;
        <a href="https://beian.miit.gov.cn/" class="copylink" target="_blank" rel="noopener noreferrer"
          >闽ICP备14014561号-2</a
        >
      </span>
      <i>|</i>
      <span>市场有风险，投资需谨慎</span>

      <a class="lz-img" target="_blank"  href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91350205302896797R-SAIC_SHOW_10000091350205302896797R1738935768893&signData=MEYCIQDaD5CLGdgLm/jzSoQvgYmKQoK9lB5yJ30O9o/e9+rDCAIhAISiDMEmJsoAOLNXG56g1zUXXvU8QTdyoLNiH/X9i8wM">
        <img src="../assets/images/lz4.png" alt="">
      </a>
    </p>
  </div>
</template>
<script>
export default {
  name: 'index-footer'
};
</script>
<style lang="less" scoped>
.footer-wrapper {
  .tips {
    font-size: 14px;
    color: #696969;
    letter-spacing: 6px;
    line-height: 18px;
    margin: 30px 0;
    text-align: center;
  }
  .footer-box {
    height: 220px;
    background: #212940;
    font-family: 'PingFangSC-Regular';
    font-size: 14px;
    color: #8795a8;
    line-height: 14px;
    .footer-content {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      justify-content: space-between;
      padding: 64px 20px 50px;
      box-sizing: border-box;
      .link-wrapper {
        display: flex;
        justify-content: flex-start;
        .link-item {
          color: #8795a8;
          margin-right: 38px;
        }
      }
      .attention {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 30px 0 38px;
        .item {
          position: relative;
          margin-right: 38px;
          cursor: pointer;
          .qr-code {
            display: none;
            width: 200px;
            // height: 220px;
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
          }
          &:hover {
            .qr-code {
              display: block;
            }
          }
        }
        .wechat {
          position: relative;
          width: 20px;
          height: 20px;
          img {
            width: 100%;
          }
        }
        .app-download {
          .btn{
            width:102px;
            height:28px;
            &.btn-ios{
              background:url('../assets/images/ios-btn.png') no-repeat;
              background-size:100% 100%;
            }
            &.btn-android{
              background:url('../assets/images/android-btn.png') no-repeat;
              background-size:100% 100%;
            }
          }
        }
      }
      .icon-wrapper {
        img {
          display: inline-block;
          margin-right: 8px;
          height: 33px;
        }
      }
      .left {
        padding-left: 40px;
      }
      .right {
        width: 440px;
        .contract-way {
          margin: 30px 0 0 0;
          span {
            margin: 0 30px 0 0;
          }
        }
        .postcode {
          margin: 16px 0;
        }
      }
    }
  }
  .copyright {
    background: #212940;
    font-family: 'PingFangSC-Regular';
    font-size: 14px;
    color: #8795a8;
    text-align: center;
    line-height: 70px;
    border-top: 2px solid #444b53;
    display: flex;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    i {
      display: inline-block;
      margin: 0px 26px;
    }
    .copylink {
      color: #8795a8;
    }
    .lz-img{
      margin-left:40px;
      img{
        display: block;
        width:30px;
      }
    }
  }
}
</style>
